import _defineProperty from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { prepareEvent } from '@sentry/core';

function getReplayEvent(_x) {
  return _getReplayEvent.apply(this, arguments);
}

function _getReplayEvent() {
  _getReplayEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var client, scope, event_id, event, preparedEvent, metadata, name;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, scope = _ref.scope, event_id = _ref.replayId, event = _ref.event;
            _context.next = 3;
            return prepareEvent(client.getOptions(), event, {
              event_id: event_id
            }, scope);

          case 3:
            preparedEvent = _context.sent;

            if (preparedEvent) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", null);

          case 6:
            // This normally happens in browser client "_prepareEvent"
            // but since we do not use this private method from the client, but rather the plain import
            // we need to do this manually.
            preparedEvent.platform = preparedEvent.platform || 'javascript'; // extract the SDK name because `client._prepareEvent` doesn't add it to the event

            metadata = client.getSdkMetadata && client.getSdkMetadata();
            name = metadata && metadata.sdk && metadata.sdk.name || 'sentry.javascript.unknown';
            preparedEvent.sdk = _objectSpread(_objectSpread({}, preparedEvent.sdk), {}, {
              version: "7.29.0",
              name: name
            });
            return _context.abrupt("return", preparedEvent);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getReplayEvent.apply(this, arguments);
}

export { getReplayEvent };